module.exports = __webpack_public_path__ + "static/media/IconLessons.c26c6da1.svg";